import React from "react";
import ThemedSpan from "../../components/utilities/ThemedSpan";
import { useMicroserviceManagement } from "./hooks/MicroserviceManagerContext";

export * from "./components/MicroserviceActionsDropdown";
export * from "./components/MicroserviceActionsDropdownItem";
export * from "./hooks/MicroserviceManagerContext";

export const MicroserviceStatusDisplay = () => {
    const { isServiceAvailable } = useMicroserviceManagement();
    return (
        <p className="mb-0">
            <span className="fw-bold">Status:</span> <ThemedSpan variant={isServiceAvailable ? 'success' : 'danger'}>{isServiceAvailable ? 'Available' : 'Unavailable'}</ThemedSpan>
        </p>
    );
};